import { render, staticRenderFns } from "./ProductInput.vue?vue&type=template&id=126235fc&"
import script from "./ProductInput.vue?vue&type=script&lang=js&"
export * from "./ProductInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports